import createReducer from './baseReducer';

export default createReducer('reservations', 'reservation');
